import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {HomeComponent} from './pages/home/home.component';
import {LoginComponent} from './pages/login/login.component';
import {EntradaCaminhoesComponent} from './pages/entrada-caminhoes/entrada-caminhoes.component';
import {PlataformaComponent} from './pages/plataforma/plataforma.component';
import {AuthGuard} from './auth/guard.service';

const routes: Routes = [
    {path: 'login', component: LoginComponent},
    {path: 'dashboard', component: HomeComponent, canActivate: [AuthGuard]},
    {path: 'portaria', component: EntradaCaminhoesComponent, canActivate: [AuthGuard]},
    {path: 'plataforma', component: PlataformaComponent, canActivate: [AuthGuard]},
    {path: '', redirectTo: '/dashboard', pathMatch: 'full'}
];

@NgModule({
    exports: [RouterModule],
    imports: [RouterModule.forRoot(routes, {})]
})
export class AppRoutingModule {}
